'use strict'

nextId = 1

module.exports = class MarkerTooltip

  id: null
  marker: null
  $hoverElement: null
  $mapContainer: null
  $tooltip: null
  $marker: null

  constructor: ({ @$hoverElement, @marker, @$mapContainer, @$tooltip, @$marker }) ->
    @id = nextId
    nextId += 1

    @$hoverElement.hover @show, @hide

    @$tooltip.find('.icon-x').click =>
      @$tooltip.removeClass 'active'

    # Close all open Tooltips when a new Tooltip is shown.
    @$mapContainer.on 'tooltip-show', (evt, { id }) =>
      @hide() unless @id is id

  show: =>
    @$tooltip.addClass 'active'
    @updateLocation()
    @$mapContainer.trigger 'tooltip-show', { id: @id }

  hide: =>
    @$tooltip.removeClass 'active'

  updateLocation: ->
    mapWidth = @$mapContainer.innerWidth()
    mapHeight = @$mapContainer.innerHeight()
    tooltipWidth = @$tooltip.outerWidth()
    tooltipHeight = @$tooltip.outerHeight()
    markerWidth = @$marker.outerWidth()
    markerHeight = @$marker.outerHeight()

    projection = @marker.getProjection()
    return unless projection?

    markerPixelPosition = projection.fromLatLngToContainerPixel @marker.getPosition()

    margin = 10

    # We first check where it would be possible to position the Tooltip,
    # and later we will choose the best one depending on which positions are possible.

    position = {}

    # We need 30 extra pixels to account for the "search as I move the map" div.
    if markerPixelPosition.y > markerHeight + tooltipHeight + margin + 30
      position.top = true

    if markerPixelPosition.y < mapHeight - (tooltipHeight + margin)
      position.bottom = true

    if markerPixelPosition.x > markerWidth + tooltipWidth + margin
      position.left = true

    if markerPixelPosition.x < mapWidth - (markerWidth + tooltipWidth + margin)
      position.right = true

    if (markerPixelPosition.x > ((markerWidth + tooltipWidth) / 2) + margin) and markerPixelPosition.x < mapWidth - (((markerWidth + tooltipWidth) / 2) + margin)
      position.center = true

    style = {}
    arrowHeight = 8

    # Reset the Tooltip style.

    @$tooltip.attr 'style', ''
    @$tooltip.removeClass 'top-center bottom-center top-left top-right bottom-left bottom-right'

    if position.top and position.center
      cssClass = 'top-center'
    else if position.top and position.left
      cssClass = 'top-left'
    else if position.top and position.right
      cssClass = 'top-right'
    else if position.bottom and position.right
      cssClass = 'bottom-right'
    else if position.bottom and position.left
      cssClass = 'bottom-left'
    else if position.bottom and position.center
      cssClass = 'bottom-center'

    # We set a CSS class to position the arrow.

    @$tooltip.addClass cssClass

    # We set inline styles to position the Tooltip.

    if /^top-/.test cssClass
      dotAdjustment = if @$marker.hasClass 'show-dot' then (markerHeight - 10) else 0
      @$tooltip.css 'top', "-#{(tooltipHeight + arrowHeight - dotAdjustment)}px"
    else if /^bottom-/.test cssClass
      if @$marker.hasClass 'show-dot'
        @$tooltip.css 'top', "#{(markerHeight + arrowHeight + 5)}px"
      else
        labelHeight = @$marker.find('.marker-label').outerHeight()
        @$tooltip.css 'top', "#{(labelHeight + arrowHeight + 5)}px"

    if /-center$/.test cssClass
      @$tooltip.css 'left', "-#{((tooltipWidth / 2) - (markerWidth / 2))}px"
    else if /-left$/.test cssClass
      @$tooltip.css 'right', 0
    else if /-right$/.test cssClass
      @$tooltip.css 'left', 0

    return
